<template>
  <div id="case" class="con">
    <navheader></navheader>
    <fixheader></fixheader>
    <div class="our_case"></div>
    <div class="container case-message">
      <el-row :gutter="50">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div class="organ mess" style="margin: 50px 0 0 0;">
            <el-link :underline="false">成功案例</el-link>
            <!-- <p style="font-size: 22px !important; font-weight: bolder;">SUCCESS STORIES</p> -->
          </div>
        </el-col>
      </el-row>
      <el-divider class="space"></el-divider>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <div class="organ" style="margin-top: 0 !important;">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-card shadow="hover">
                <i class="el-icon-s-management classification"></i>
                <h3>手册系列</h3>
                <div class="hideclass">
                  <el-divider content-position="center">※汽车系列※</el-divider>
                  <ul>
                    <li>修理手册</li>
                    <li>新车特征</li>
                    <li>电路图</li>
                    <li>车身损伤修理手册</li>
                    <li>工时手册</li>
                    <li>用户手册</li>
                    <li>导航系统用户手册</li>
                    <li>袖珍驾驶员手册</li>
                    <li>分解手册</li>
                    <li>应急指南等</li>
                  </ul>
                  <el-divider content-position="center">※机床系列※</el-divider>
                  <ul>
                    <li>机床使用说明书</li>
                    <li>构造原理说明书</li>
                    <li>维护说明书</li>
                    <li>编程说明书</li>
                    <li>零部件图册</li>
                    <li>数控机床电脑画面</li>
                    <li>警告信息等</li>
                  </ul>
                  <el-divider content-position="center">※叉车系列※</el-divider>
                  <ul>
                    <li>修理手册</li>
                    <li>使用手册等</li>
                  </ul>
                  <el-divider content-position="center">※织机系列※</el-divider>
                  <ul>
                    <li>使用说明书</li>
                    <li>安全作业说明书</li>
                    <li>结构功能说明书等</li>
                  </ul>
                  <el-divider content-position="center">※电机系列※</el-divider>
                  <ul>
                    <li>构造原理说明书</li>
                    <li>维护说明书等</li>
                  </ul>
                  <el-divider content-position="center">※卫生洁具系列※</el-divider>
                  <ul>
                    <li>使用说明书</li>
                    <li>安装说明书等</li>
                  </ul>
                  <el-divider content-position="center">※宣传册系列※</el-divider>
                  <ul>
                    <li>企业宣传册</li>
                    <li>汽车宣传手册系列</li>
                    <li>手机手册系列</li>
                  </ul>
                </div>
                <!-- <el-button :class="{'el-icon-caret-top':!isA,'el-icon-caret-bottom':isA}" @click="toggle()"></el-button> -->
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-card shadow="hover">
                <i class="el-icon-monitor classification"></i>
                <h3>软件系列</h3>
                <div class="hideclass">
                  <el-row :gutter="10" style="text-align: left;">
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      中日英汽车信息快译宝软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      中日英汽车信息快译宝软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      汽车信息自动转换系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      机床信息自动转换系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      医疗财会核实软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      医药仓储管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      出租车信息管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      广兴企业管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      税政信息管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      政企信息管理系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      人力资源信息数据管理系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      数据处理智能控制软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      多媒体信息整合及管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      数字化文档自动转换综合管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      多媒体汽车培训教程软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      汽车RM系列软件系列软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      汽车经销顾问培训体系考试系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      台湾语汽车修理手册自动转换模板软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      汽车经销店抽奖软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      市政园林局绿化养护管理系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      涉税信息管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      多媒体信息整合及管理系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      移动终端多媒体监控系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      汽车维修技能多媒体培训系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      公文信息归置软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      双语文档统一词汇智能检测软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      服装进销存管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC中英汽车专用词典软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC批量文件更名软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC文档错别字自动检测软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC物流信息管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC汽车图档管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC汽车4S店客户信息管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC人力资源人事管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC汽车手册编写与智能DTP软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC网上项目库管理系统
                    </el-col>
                  </el-row>
                </div>
                <!-- <el-button :class="{'el-icon-caret-top':!isB,'el-icon-caret-bottom':isB}" @click="toggle2()"></el-button> -->
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-card shadow="hover">
                <i class="el-icon-s-flag classification"></i>
                <h3>著作软件</h3>
                <div class="hideclass">
                  <el-row :gutter="10" style="text-align: left;">
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 房产图档管理系统软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 日文输入法软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 日文报刊建置管理系统软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 汽车信息快译宝软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 各类活动抽奖软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 试卷自动生成软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 数据自动转换软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 药品信息管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 税政信息管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 机床信息快译宝软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 汽车中英对照培训教程软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC- 医疗财会核实软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      涉税信息管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      多媒体信息整合及管理系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      移动终端多媒体监控系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC汽车维修技能多媒体培训系统
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC公文信息归置软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC双语文档统一词汇智能检测软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC服装进销存管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC中英汽车专用词典软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC批量文件更名软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC文档错别字自动检测软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC物流信息管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC汽车图档管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC汽车4S店客户信息管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC人力资源人事管理软件
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      GC网上项目库管理系统
                    </el-col>
                  </el-row>
                </div>
                <!-- <el-button :class="{'el-icon-caret-top':!isC,'el-icon-caret-bottom':isC}" @click="toggle3()"></el-button> -->
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-card shadow="hover">
                <i class="el-icon-picture-outline classification"></i>
                <h3>图片展示</h3>
                <div class="hideclass">
                  <el-row :gutter="10" style="text-align: left;">
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      <el-card class="box-card">
                        <div>
                          <img src="../assets/img/anli/anli1.gif" />
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      <el-card class="box-card">
                        <div>
                          <img src="../assets/img/anli/anli2.gif" />
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      <el-card class="box-card">
                        <div>
                          <img src="../assets/img/anli/anli3.gif" />
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      <el-card class="box-card">
                        <div>
                          <img src="../assets/img/anli/anli4.gif" />
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-card class="box-card box-set">
                        <div>
                          <img src="../assets/img/anli/anli5.jpg" />
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-card class="box-card box-set">
                        <div>
                          <img src="../assets/img/anli/anli6.jpg" />
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-card class="box-card box-set">
                        <div>
                          <img src="../assets/img/anli/anli7.jpg" />
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-card class="box-card box-set">
                        <div>
                          <img src="../assets/img/anli/anli8.jpg" />
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-card class="box-card box-set">
                        <div>
                          <img src="../assets/img/anli/anli9.jpg" />
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-card class="box-card box-set">
                        <div>
                          <img src="../assets/img/anli/anli10.jpg" />
                        </div>
                      </el-card>
                    </el-col>
                  </el-row>
                </div>
                <!-- <el-button :class="{'el-icon-caret-top':!isC,'el-icon-caret-bottom':isC}" @click="toggle3()"></el-button> -->
              </el-card>
            </el-col>
          </el-row>
        </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <filing></filing>
  </div>
</template>

<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import filing from '@/components/Filing.vue'
  export default {
    name: 'organ',
    components: {
      navheader,
      fixheader,
      filing
    },
    data() {
      return {
        activeName: 'first',
        isA: false,
        isB: false,
        isC: false
      }
    },
    mounted: function() {
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      toggle() {
        this.isA = !this.isA
      },
      toggle2() {
        this.isB = !this.isB
      },
      toggle3() {
        this.isC = !this.isC
      }
    }
  }
</script>

<style>
  .con .case-message .el-tabs__active-bar {
    width: 56px !important;
  }

  .con .case-message .organ .el-row .el-col .el-card {
    height: 175px;
    min-height: 175px;
  }

  .con .case-message .el-col {
    margin: 10px 0 !important;
  }

  #case .organ .el-row .el-col .el-card {
    height: auto !important;
    max-height: 5000px !important;
  }

  #case .hideclass {
    overflow: inherit !important;
    height: auto !important;
  }

  #case div.space {
    height: 3px !important;
    position: relative;
  }

  #case div.space:before {
    position: absolute;
    content: "";
    top: 0;
    width: 160px;
    height: 3px;
    background-color: rgba(0, 0, 0, 0.6);
    right: calc(50% - 80px);
  }

  #case .el-card__body {
    text-align: center !important;
    overflow: hidden;
  }

  #case .el-card__body>div {
    overflow: hidden;
  }

  #case .box-set {
    min-height: 320px !important;
    overflow: hidden;
    padding: 10px 15px !important;
  }

  #case .box-set img {
    height: 320px;
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/content/Our_case.vue